<div class="container-fluid admin-form-page">
  <form class="admin-form" ngNativeValidate (ngSubmit)="updateRatingCategory()">
    <div class="row section1 align-items-center">
      <div class="col-12 col-md-7 col-lg-7 col-xl-7">
        <div class="home-details">
          <h5 class="home-title">Edit Existing Rating Category</h5>
          <p class="home-subtitle">Enter all Category details</p>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage admin-page-actions">
          <a routerLink="/rating-categories">
            <button type="button" class="btn btn-primary btn-dashboard">Back</button>
          </a>
          <button type="submit" class="btn btn-primary btn-dashboard">Save details</button>
        </div>
      </div>
    </div>

    <div class="section1">
      <div class="applicants-details details1 admin-form-card">
        <div class="admin-form edit-rating-page">
          <section class="form-section">
            <h5 class="section-title">Category Details</h5>

            <div class="row align-items-end">
              <div class="col-12 col-lg-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="category-name">Rating Category Name*</label>
                    <input type="text"
                      class="form-control"
                      id="category-name"
                      [(ngModel)]="rateCategory.name"
                      name="category-name"
                      placeholder="Rating category Name"
                      required>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="popular">Is Popular*</label>
                    <select id="popular" name="popular_index" class="form-control" [(ngModel)]="rateCategory.popular_index">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="cat-icon">Category Icon*</label>
                    <input type="file"
                      class="form-control"
                      id="cat-icon"
                      name="cat-icon"
                      accept="image/*"
                      (change)="uploadImage($event)">
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="icon-preview-box">
                  @if (rateCategory.icon) {
                    <img [src]="rateCategory.icon" alt="Category icon">
                  }
                </div>
              </div>
            </div>
          </section>

          <section class="form-section">
            <h5 class="section-title">Rating Rules</h5>
            <div class="row">
              <div class="col-12 col-lg-6">
                <label>Rating Positive/Negative Criteria Type*</label>
                <div class="criteria-options">
                  <label class="criteria-option" for="SecularismType">
                    <input type="radio"
                      id="SecularismType"
                      [(ngModel)]="rateCategory.RatingPositiveNegativeCriteriaType"
                      value="secularism_index"
                      name="PositiveNegativeCriteriaType">
                    <span>Parameter 1 should be greater than 2 and 3</span>
                  </label>
                  <label class="criteria-option" for="BhaktType">
                    <input type="radio"
                      id="BhaktType"
                      value="bhakt_index"
                      name="PositiveNegativeCriteriaType"
                      [(ngModel)]="rateCategory.RatingPositiveNegativeCriteriaType">
                    <span>All parameters should be greater than specific percentage</span>
                  </label>
                </div>
              </div>

              @if (rateCategory.RatingPositiveNegativeCriteriaType === 'bhakt_index') {
                <div class="col-12 col-lg-3">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="positive-percent">Minimum percentage for positive rating*</label>
                      <input type="tel"
                        class="form-control"
                        id="positive-percent"
                        name="RatingPositiveNegativePercent"
                        [(ngModel)]="rateCategory.RatingPositiveNegativePercent"
                        required
                        maxlength="3"
                        placeholder="Enter percentage"
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')">
                      </div>
                    </div>
                  </div>
                }
              </div>
            </section>

            @if (rateCategory.category) {
              <section class="form-section">
                <h5 class="section-title">Category Mapping</h5>
                <label class="mb-2 d-block">Select categories (At least one)*</label>
                <div class="chip-list">
                  @for (c of categories; track c) {
                    <label class="category-chip" [for]="'category'+c.id">
                      <span>{{c.categoryName}}</span>
                      <input type="checkbox"
                        [checked]="isCategoryChecked(c.id)"
                        [id]="'category'+c.id"
                        [value]="c.id"
                        (change)="catChange($event, c.id)">
                    </label>
                  }
                </div>
              </section>
            }

            <section class="form-section">
              <h5 class="section-title">Description</h5>
              <angular-editor placeholder="Enter Description"
                name="description"
                [(ngModel)]="rateCategory.description"
                id="description"
                [config]="editorConfig">
              </angular-editor>
            </section>

            <section class="form-section">
              <h5 class="section-title">Rating Parameters</h5>

              @for (item of rateCategory['parameters']; track item; let ind = $index) {
                <div class="param-row">
                  <div class="row align-items-end">
                    <div class="col-12 col-lg-4">
                      <div class="user-form">
                        <div class="form-group">
                          <label for="param-name-{{ind}}">Parameter Name*</label>
                          <input type="text"
                            class="form-control"
                            id="param-name-{{ind}}"
                            [(ngModel)]="rateCategory.parameters[ind].fieldName"
                            name="param-{{ind+1}}"
                            placeholder="Enter Parameter Name"
                            required>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="user-form">
                        <div class="form-group">
                          <label for="param-icon-{{ind}}">Rating Icon*</label>
                          <input type="file"
                            class="form-control"
                            id="param-icon-{{ind}}"
                            name="icon-{{ind}}"
                            accept="image/*"
                            [required]="item.icon == ''"
                            (change)="pickIcon($event, ind)">
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-1">
                      <div class="icon-preview-box small">
                        @if (item.icon) {
                          <img [src]="item.icon" alt="Rating icon">
                        }
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="user-form">
                        <div class="form-group">
                          <label for="param-description-{{ind}}">Description*</label>
                          <input class="form-control"
                            type="text"
                            id="param-description-{{ind}}"
                            name="description-{{ind}}"
                            required
                            [(ngModel)]="item.description">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </section>
          </div>
        </div>
      </div>
    </form>
  </div>
